import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { FlightTicketPropType } from 'PropTypes';

import StatusStaffTabsRow from 'Components/StatusStaffTabsRow';
import BusinessSupportCard from 'Views/TicketProfile/Components/BusinessSupportCard';
import CommentsCard from 'Views/TicketProfile/Components/CommentsCard';

const BusinessSupportTab = (props) => {
  const {
    flyToWorkTicketInfo,
    setRefreshComponent,
    refreshComponent,
    setFlyToWorkTicketInfo,
    isLockRequired,
    resetLockTimers,
  } = props;

  useEffect(() => {}, [refreshComponent]);

  return (
    <React.Fragment>
      <StatusStaffTabsRow flyToWorkTicketInfo={flyToWorkTicketInfo} />
      <hr style={{ marginTop: 0 }} />
      <BusinessSupportCard
        flyToWorkTicketInfo={flyToWorkTicketInfo}
        setRefreshComponent={setRefreshComponent}
        setFlyToWorkTicketInfo={setFlyToWorkTicketInfo}
      />
      <CommentsCard
        flyToWorkTicketInfo={flyToWorkTicketInfo}
        setRefreshComponent={setRefreshComponent}
        refreshComponent={refreshComponent}
        isLockRequired={isLockRequired}
        resetLockTimers={resetLockTimers}
      />
    </React.Fragment>
  );
};

BusinessSupportTab.propTypes = {
  flyToWorkTicketInfo: FlightTicketPropType.isRequired,
  setRefreshComponent: PropTypes.func.isRequired,
  refreshComponent: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  setFlyToWorkTicketInfo: PropTypes.func.isRequired,
  isLockRequired: PropTypes.bool,
  resetLockTimers: PropTypes.func,
};

export default BusinessSupportTab;
